import './LynchButton.scss';
import gun from '../img/gun.png';

export function LynchButton(props: {onClick: () => void}) {
    const {onClick} = props;

    return <div className="lynch-button-wrapper">
        <button onClick={onClick}>Lynch Me! <img  src={gun}/></button>
        
    </div>
}